module.exports = __webpack_public_path__ + "static/media/bg-grid.e3425c46.png";